import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { getIconStyles as o } from "../styles.js";
const r = (d) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: o(d),
    children: [
      /* @__PURE__ */ e("g", { clipPath: "url(#clip0_3922_22217)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.25 1.49805C1.83579 1.49805 1.5 1.83383 1.5 2.24805V21.748C1.5 22.1623 1.83579 22.498 2.25 22.498H21.75C22.1642 22.498 22.5 22.1623 22.5 21.748V2.24805C22.5 1.83383 22.1642 1.49805 21.75 1.49805H2.25ZM0 2.24805C0 1.00541 1.00736 -0.00195312 2.25 -0.00195312H21.75C22.9926 -0.00195312 24 1.00541 24 2.24805V21.748C24 22.9907 22.9926 23.998 21.75 23.998H2.25C1.00736 23.998 0 22.9907 0 21.748V2.24805Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.5 5.24805C13.5 4.83383 13.8358 4.49805 14.25 4.49805H18.75C19.1642 4.49805 19.5 4.83383 19.5 5.24805C19.5 5.66226 19.1642 5.99805 18.75 5.99805H14.25C13.8358 5.99805 13.5 5.66226 13.5 5.24805Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 9.74805C12 9.33383 12.3358 8.99805 12.75 8.99805H18.75C19.1642 8.99805 19.5 9.33383 19.5 9.74805C19.5 10.1623 19.1642 10.498 18.75 10.498H12.75C12.3358 10.498 12 10.1623 12 9.74805Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 14.248C12 13.8338 12.3358 13.498 12.75 13.498H18.75C19.1642 13.498 19.5 13.8338 19.5 14.248C19.5 14.6623 19.1642 14.998 18.75 14.998H12.75C12.3358 14.998 12 14.6623 12 14.248Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 18.748C12 18.3338 12.3358 17.998 12.75 17.998H17.25C17.6642 17.998 18 18.3338 18 18.748C18 19.1623 17.6642 19.498 17.25 19.498H12.75C12.3358 19.498 12 19.1623 12 18.748Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 5.24805C4.5 4.83383 4.83579 4.49805 5.25 4.49805H9.75C10.1642 4.49805 10.5 4.83383 10.5 5.24805V9.74805C10.5 10.1623 10.1642 10.498 9.75 10.498H5.25C4.83579 10.498 4.5 10.1623 4.5 9.74805V5.24805ZM6 5.99805V8.99805H9V5.99805H6Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.5 14.248C4.5 13.8338 4.83579 13.498 5.25 13.498H9.75C10.1642 13.498 10.5 13.8338 10.5 14.248V18.748C10.5 19.1623 10.1642 19.498 9.75 19.498H5.25C4.83579 19.498 4.5 19.1623 4.5 18.748V14.248ZM6 14.998V17.998H9V14.998H6Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_3922_22217", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  r as TemplateIcon
};
//# sourceMappingURL=TemplateIcon.js.map
